export default __webpack_public_path__ + "static/media/slogan.edd75058.png";